import { useEffect, useRef } from 'react';

import { cn } from './cn.js';

import type { ReactElement, ReactNode } from 'react';

interface GlassModalProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
}

export function GlassModal({
  open,
  onClose,
  children,
  className,
}: GlassModalProps): ReactElement | null {
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) {
      return;
    }
    const handleEsc = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEsc);
    return (): void => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div
      ref={overlayRef}
      className="fixed inset-0 z-50 flex items-center justify-center bg-bg-overlay backdrop-blur-sm animate-[fadeIn_0.15s_ease]"
      onClick={(e) => {
        if (e.target === overlayRef.current) {
          onClose();
        }
      }}
    >
      <div
        className={cn(
          'glass-strong rounded-2xl p-6 max-w-md w-full mx-4',
          'shadow-[var(--glass-shadow-lg)]',
          'animate-[slideUp_0.2s_ease]',
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
